import {Component, Input} from '@angular/core';
import {AbstractAction} from '../abstract-action';

@Component({
    selector: 'vui-submit-action',
    templateUrl: './submit-action.component.html',
    styleUrls: ['./submit-action.component.scss']
})
export class SubmitActionComponent extends AbstractAction{
    @Input() public state: string;

    constructor() {
        super();
    }
}
